import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TurnstileService } from '../../shared/services/turnstile.service';
import { SignupApiService, apiError } from '../signup-api.service';

// ncommerce.app/cadastro: name, e-mail and WhatsApp; the master sends the
// link that finishes the signup on the PC that will run NCommerce. A plan
// picked on the home page comes as ?plano=essencial and goes with the lead.
@Component({
    selector: 'app-signup-lead',
    templateUrl: './signup-lead.component.html',
    styleUrls: ['../signup.scss'],
    standalone: false
})
export class SignupLeadComponent {
  name = '';
  email = '';
  whatsapp = '';
  loading = false;
  error = '';
  sentTo = '';
  readonly planNames: Record<string, string> = { free: 'Grátis', essencial: 'Essencial', completo: 'Completo' };
  chosenPlan = '';

  constructor(private api: SignupApiService, private turnstile: TurnstileService, private route: ActivatedRoute) {
    this.turnstile.warmup();
    const plan = this.route.snapshot.queryParamMap.get('plano') || '';
    this.chosenPlan = this.planNames[plan] ? plan : '';
  }

  canSend(): boolean {
    return !!this.name.trim() && /\S+@\S+\.\S+/.test(this.email) && this.whatsapp.replace(/\D/g, '').length >= 10;
  }

  send(): void {
    if (!this.canSend() || this.loading) {
      return;
    }
    this.loading = true;
    this.error = '';
    const source = this.route.snapshot.queryParamMap.get('utm_source') || this.route.snapshot.queryParamMap.get('origem') || '';

    this.turnstile.getToken().then(
      token => this.api.requestLink({ name: this.name.trim(), email: this.email.trim(), whatsapp: this.whatsapp, source,
                                    chosen_plan: this.chosenPlan || undefined }, token)
        .subscribe({
          next: res => {
            this.loading = false;
            this.sentTo = res.email;
          },
          error: err => {
            this.loading = false;
            this.error = apiError(err);
          }
        }),
      () => {
        this.loading = false;
        this.error = 'Não foi possível verificar o navegador. Atualize a página e tente de novo.';
      }
    );
  }
}
